import { allBrands, datatypes, inputTypes, arrType, selectOptionsKeyName } from "data/globalData";
import moment from "moment";
import { roundDecimalValueUptoTwo } from "utils/RoundDecimalValue";

export const merchantTableColumns = [
	{
		name: "RR Code",
		key: "i_code",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
		default_value: "",
	},
	{
		name: "Season",
		key: "season",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
	{
		name: "Vendor Name",
		key: "vendor_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	},
	{
		name: "Cost",
		key: "cost",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 1,
		default_value: "",
		renderCell: ({ row, field }) => {
			return roundDecimalValueUptoTwo(+row[field]);
		},
	},
	{
		name: "Planned Sample Handover",
		key: "planned_sample_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		editable: true,
		type: "date",
	},
	{
		name: "Actual Sample Handover",
		key: "actual_sample_handover",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		default_value: "",
	},

	{
		name: "Expected Production Inward",
		key: "expected_production_Inward",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		default_value: "",
		editable: true,
		type: "date",
	},

	{
		name: "Actual Production Inward",
		key: "actual_production_Inward",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		default_value: "",
		editable: true,
		type: "date",
	},
];

export const mearchatSkuDummyData = [
	{
		barcode: "RR1234",
		i_code: "RR1234",
		season: "AW-25",
		vendor_name: "AURA EXPORTS",
		cost: 450,
		planned_sample_handover: moment().format("YYYY-MM-DD"),
		actual_sample_handover: "2025-08-12",
		expected_production_Inward: moment().format("YYYY-MM-DD"),
		actual_sample_recieved_date: "",
		id: 1,
		created_by: "adarsh.h@thehouseofrare.com",
		last_updated_by: "adarsh.h@thehouseofrare.com",
	},
	{
		barcode: "RR3456",
		i_code: "RR3456",
		season: "AW-25",
		vendor_name: "AURA EXPORTS",
		cost: 450,
		planned_sample_handover: moment().format("YYYY-MM-DD"),
		actual_sample_handover: "2025-08-12",
		expected_production_Inward: moment().format("YYYY-MM-DD"),
		actual_sample_recieved_date: "",
		id: 1,
		created_by: "adarsh.h@thehouseofrare.com",
		last_updated_by: "adarsh.h@thehouseofrare.com",
	},
];
